exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkBoxButtonPrediction\n{\n\nposition:relative;\nmargin-top:40px;\n}", ""]);

